import { useContext, useEffect, useState } from 'react';

import { SearchAssetQuery, SearchAssetResult } from '../../entity/SearchAsset';
import SearchAssetApi from '../../service/persistent/SearchAssetApi';
import { context as StateContext } from '../../view/context/state';

export const useSearchApi = (searchQuery: SearchAssetQuery) => {
  const [client] = useState(new SearchAssetApi());
  const [data, setData] = useState<SearchAssetResult>([]);
  const [query, setQuery] = useState(searchQuery);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const state = useContext(StateContext);
  const organizationId = state.lastAccessedOrganization?.id;

  useEffect(() => {
    setIsLoading(true);

    const fetchData = async () => {
      if (query.reset) {
        setData([]);
      }
      setIsError(false);

      try {
        const result = await client.search({ ...query, organizationId });

        if (query.reset) {
          setData(result);
        } else {
          setData([...data, ...result]);
        }
      } catch (error) {
        setIsError(true);
      }

      setIsLoading(false);
    };

    if (query != null) {
      fetchData();
    }
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return [{ data, isLoading, isError }, setQuery] as const;
};
